import { addTotalColumnGeneric, transformData } from "./utils";
import { getDateString } from "../../../utils/dateutils";
import {
  getMonthlyColumns,
  getQuarterColumns,
  TWELVE_MONTHS_COLUMNS,
  YEAR_COLUMNS,
} from "./reportingLogsColumns";

/**
 * Builds the table config array for ReportingLogs based on current data and config.
 */
export function getTableConfigs({
  reportingData,
  months,
  quarters,
  mapper,
}) {
  const tableData = { mapper, months, quarters };

  return [
    {
      key: "monthlySummary",
      title: "Monthly Summary",
      dataSource: addTotalColumnGeneric(
        reportingData.monthlySummary
          ? transformData(reportingData.monthlySummary, tableData)
          : [],
      ),
      columns: getMonthlyColumns(months),
      expandable: {
        enabled: true,
        expandKey: "monthlySummary",
        keyName: (record) => record.value,
        expandTitle: "Clinical Staff Hours",
        expandTitles: ["Clinical Staff Hours", "Activity Hours (Samaritan)"],
      },
    },
    {
      key: "patientReporting",
      title: "Patient Reporting",
    },
    {
      key: "volunteersReporting",
      title: "Volunteer Reporting",
      dataSource: addTotalColumnGeneric(
        reportingData.volunteersReporting
          ? transformData(reportingData.volunteersReporting, tableData)
          : [],
        ["noHoursVolunteer"],
      ),
      columns: getMonthlyColumns(months),
      expandable: { enabled: false },
    },
    {
      key: "mileageSummary",
      title: "Mileage Summary",
      dataSource: addTotalColumnGeneric(
        reportingData.mileageSummary
          ? transformData(reportingData.mileageSummary, tableData)
          : [],
      ),
      columns: getMonthlyColumns(months),
      expandable: { enabled: false },
    },
    {
      key: "special5PercentReport",
      title: "Special 5% Report",
      subTitle: `From ${getDateString(
        reportingData.special5PercentReport?.startDate,
      )} to ${getDateString(reportingData.special5PercentReport?.endDate)}`,
      dataSource: reportingData.special5PercentReport
        ? transformData(
            (() => {
              const { startDate, endDate, ...cleanedData } =
                reportingData.special5PercentReport;
              return [cleanedData];
            })(),
            tableData,
          )
        : [],
      columns: TWELVE_MONTHS_COLUMNS,
      expandable: { enabled: false },
    },
    {
      key: "volunteerRetention",
      title: "Volunteer Retention Report",
      dataSource: reportingData.volunteerRetention
        ? transformData([reportingData.volunteerRetention], tableData)
        : [],
      columns: YEAR_COLUMNS,
      expandable: { enabled: false },
    },
    {
      key: "measuresOfExcellent",
      title: "Measure Of Excellence",
      dataSource: reportingData.measuresOfExcellent
        ? transformData(reportingData.measuresOfExcellent, tableData)
        : [],
      columns: getQuarterColumns(quarters),
      expandable: { enabled: false },
    },
  ];
}
